import {
  mapState,
  mapMutations,
  mapGetters,
  createNamespacedHelpers,
} from "vuex";

import { roll, conversion, typeRate } from "@/tool";
import Utils from "@/tool/util";
import * as Validation from "@/utils/validation";

import {
  sessionLogin,
  mobileRegisterApi,
  GetSystemInfo,
  sendMobileCode, //手机号注册发送验证码
  sendResetCode, //手机号修改密码发送验证码
  api_GetAcl,
  api_RankingEvents,
} from "@/api";
import * as apis from "@/api";
import Sidebar from "@/partials/sidebar";
import TradeoffBox from "@/partials/tradeoffer";

import CustomButton from "@/partials/custom_button";

import Avatar from "@/components/avatar";
import Picture from "@/components/picture";
import Button from "@/components/button";
import InteractivePanel from "@/components/interactive_panel";
import { Modal, use_modal } from "@/components/modal";
import Award from "@/components/award";
import Recharge from "@/partials/recharge/recharge.vue";
import redPacket from "@/partials/red_packet";
import LiveDropBox from "@/partials/live_drop_box";

import welfareCenter from "@/pages/event1";

import click_sound from "@/assets/audio/click.mp3";
import Number from "@/components/AnimateNumber/index.vue";
import DropMenu from "@/components/dropmenu/index.vue";
import LoadingScope from "@/components/UI/LoadingScope/index.vue";
import Cookies from "@/utils/cookie";
import NavSvg from "./components/navSvg/index";
import { resetRouter } from "../../router/index";
import { navsList } from "../../utils/enum";
import { normalizeFeatureAccess } from "@/utils/feature-access";


import NotificationCard from "@/pages/multiplePeopleCase/components/NotificationCard.vue";


export default {
  components: {
    "p-sidebar": Sidebar,
    "p-tradeofferbox": TradeoffBox,
    "p-custom-button": CustomButton,
    "p-recharge": Recharge,
    "p-red-packet": redPacket,
    "p-live-drop-box": LiveDropBox,
    "c-avatar": Avatar,
    "c-picture": Picture,
    "c-button": Button,
    "c-modal": Modal,
    "c-interactive-panel": InteractivePanel,
    "c-award": Award,
    "c-welfareCenter": welfareCenter,
    "c-number": Number,
    "c-dropmenu": DropMenu,
    "c-loading-scope": LoadingScope,
    "c-nav-svg": NavSvg,
    "c-notification-card": NotificationCard,
  },

  filters: {
    conversion,
  },

  data() {
    return {
      acl: ["/battle"],
      hasRank: false, // 是否有活动进行中
      showDropdown: false,
      clickSound: null,
      case_category: [],
      isRouterAlive: true,
      accountFlag: false,
      language: "chinese_simplified",
      fullPath: false,
      //首页欢迎关闭
      indexFlag: false,
      transitionFlag: false,
      loginFirst: false, //登录前置弹窗
      welfareCat: 0, //福利中心页签分类索引号
      welfareCenterFlag: false,
      helpCenterData: {
        activename: "1-1",
        opennames: ["1"],
      },
      path: this.$route.name,
      nicknameChangedData: {
        flag: false,
        value: "",
      },
      oneRun: 1,
      onlineNumber: 0,
      Alert: false,
      announcementText: "",
      //弹窗
      modal: {
        //手机号注册
        mobileSignData: {
          phone: "",
          phoneError: false,
          password: "",
          passwordError: false,
          code: "",
          codeError: false,
          time: 61,
          invite: "",
        },
        //通过手机号修改密码
        resetWithPhone: {
          phone: "",
          phoneError: false,
          code: "",
          codeError: false,
          password: "",
          passwordError: false,
          password2: "",
          password2Error: false,
          time: 61,
        },
        bindIdCard: "",
      },
      activeIndex: "",
      parentIndex: "",
      lastResultIndex: "",
      aclList: [],
      navsList: navsList,
      /** 页眉信息栏 用户信息 是否激活 */
      is_header_info_bar_user_info_active: false,

      /** 客服信息 是否激活 */
      is_service_active: false,

      /** 是否隐藏导航 */
      is_header_hidden_nav: false,

      /** 侧边栏是否显示 */
      is_sidebar_show: true,

      /* 手机左侧边栏 */
      mobile_sidebar_left_show: false,

      /* 手机右侧边栏 */
      mobile_sidebar_right_show: false,

      /** 公告栏是否允许自动播放 */
      can_autoplay_bulletion_board: false,

      prize: {
        showPrize: { names: ["", "", ""] },
        prizeFlag: false,
      },

      user_drop_menu_show: false,

      // 是否提交，用户登录和注册按钮
      isSubmit: false,

      //默认为pc端一直展示
      isShowLiveDrop: true,

      isShowDropdown: false,

      //合开通知栏
      showMpCaseNotification: false,
      curMpCaseData: {
        cases: [],
        id: 0,
        currAmount: 0,
        price: 0,
        endTime: "",
        status: 0
      },
      multiplePeopleCaseRecentList: [],

      //授权登录方式
      otherLoginList: [

      ],
      
      mpcCaseTimer: null, // 用于存储计时器对象
      aclTimer: null, // 用于存储监听权限计时器对象
      isShowQQ: true,
      systemAuthSwitch: {
        System_Register: "0",
        System_Login: "0",
      },
      mpcaseNoticeModal: {

      }
    };
  },
  computed: {
    ...mapState([
      "user",
      "config",
      "loginModal",
      "PayModal",
      "RedPacketModal",
      "discounting",
      "Invitation",
      "information",
      "banner_list",
      "GobalInfo",
      "boxList",
      "notice_list",
      "isMute",
      "spinShow",
      "currentCate",
      "mpCaseList",
    ]),
    currentYear() {
      return new Date().getFullYear();
    },

    showRegister() {
      return this.systemAuthSwitch.System_Register === "1";
    },
    showLogin() {
      return this.systemAuthSwitch.System_Login === "1";
    },
    currencyType() {
      const route = this.$route || {};
      const queryCurrencyType = route.query && route.query.currencyType;
      const routeCurrencyType = route.meta && route.meta.currencyType;
      if (queryCurrencyType != null) return parseInt(queryCurrencyType, 10) || 0;
      if (routeCurrencyType != null) return parseInt(routeCurrencyType, 10) || 0;
      if (route.name === "jollybeans" || route.path === "/jollybeans") return 1;
      if (route.name === "goldbeans" || route.path === "/goldbeans") return 2;
      return 0;
    },
    showHappyCoinBalance() {
      if (this.currencyType) return this.currencyType === 1;
      return this.$route.path === "/worldcup" || this.$route.name === "worldcupDetail" || this.isHappyCoin;
    },
    showCoin1Balance() {
      return this.currencyType === 2;
    },
  },

  watch: {
    $route(to, from) {
      /*关闭侧边栏*/
      this.mobile_sidebar_left_show = false;
      this.mobile_sidebar_right_show = false;

      this.switchRoute(to.meta.navRouteName || to.name);
      document.documentElement.scrollIntoView({
        behavior: "auto",
        block: "start",
        inline: "nearest",
      });
      let flag = ["recharge", "inventory", "agency", "information"].some(
        (item) => {
          return to.name === item;
        }
      );
      if (flag) {
        this.path = to.name;
      }
      this.isShowDropComp();
      this.setSpinShow(true);
    },
  },
  async beforeRouteUpdate(to, from, next) {
    this.toggle_header_info_bar_user_info_active(false);
    next();
  },
  async created() {
    let language = localStorage.getItem("language");
    if (language && language != "") {
      this.language = language;
    }
    await this.onInitData();

    //监听MPCaseFinished 开箱成功通知
    this.onListenMPCaseFinished();
    //监听多人开箱倒计时
    this.countdownHandle();

    
    //移动端关闭右侧边栏
    if (document.documentElement.clientWidth < 769) {
      this.is_sidebar_show = false;
    }
  },
  async mounted() {
    window.addEventListener("mousedown", this.handleonmousedown);
    this.clickSound = new Audio(click_sound);
    //监听多人开箱倒计时
    this.countdownHandle();
    // 监听设置每隔5分钟执行获取权限一次
    this.aclTimer = setInterval(() => {
      this.refreshFrontendAccess();
    }, 5 * 60 * 1000);

  },
  beforeDestroy() {
    if (this.mpcCaseTimer) {
      clearInterval(this.mpcCaseTimer);
    }
    if (this.aclTimer) {
      clearInterval(this.aclTimer);
    }
  },
  methods: {
    ...mapMutations([
      "setloginModal",
      "setPayModal",
      "setInfo",
      "getboxList",
      "RequestTradeOffer",
      "setBannerList",
      "setNoticeList",
      "setSystemAuthSwitch",
      "toggle_muted",
      "load_muted",
      "setSpinShow",
    ]),
    async onInitData() {
      const _this = this;
      await _this.setInfo();
      await _this.getGlobalInfo();
      await _this.isShowDropComp();
      await _this.GetFeatureAccess();
      await _this.GetAcl();
      await _this.onAclHandle();
      await _this.switchRoute(this.$route.meta.navRouteName || this.$route.name);
      await _this.getMPCaseSettings();
      await _this.load_muted();
      await _this.getRanks();

      await this.getMultiplePeopleCaseRecentList();


      await this.initmpCaseHub();

      setTimeout(async () => {
        await this.getMPCaseSettings();
      }, 1000);
    },
    initmpCaseHub() {
      if (this.$mpCaseHub.conn.state == "Connected") {
        console.log("已连接11");
        this.getCaseList();
      }

      this.$mpCaseHub.onConnected = () => {
        console.log("已连接22");
        this.getCaseList();
      };

      this.$mpCaseHub.onReconnected = () => {
        console.log("已连接33");
        this.getCaseList();
      };
    },
    onMPCasePlayerJoin(id) {
      console.log('用户请求加入的局ID为:', id);
      this.$router.push({
        name: "multiplePeopleCaseDetail",
        params: { id },
        query: this.$route.query || {},
      });
    },
    countdownHandle() {
      this.mpcCaseTimer = setInterval(() => {
        const now = Date.now();
        const end = new Date(this.mpCaseList.mpcCaseSettings.mpCaseEndTime).getTime();
        const diff = end - now;
        if (diff <= 0) {
          clearInterval(this.mpcCaseTimer);
          // 倒计时结束
          this.getMPCaseSettings();
          return;
        }
      }, 1000);
    },
    async getMPCaseSettings() {
      const response = await apis.getMPCaseSettings();
      if (response.data.code !== 0) {
        return;
      }
      this.mpCaseList.mpcCaseSettings = response.data.data;
      this.mpCaseList.mpcCaseSettings.mpCaseEndTime = new Date(
        this.mpCaseList.mpcCaseSettings.mpCaseEndTime
      ).getTime();
    },
    onListenMPCaseFinished() {
      this.$mpCaseHub.conn.on("MPCaseFundUpdated", (data) => {
          console.log("创建合开通知", data);

          if(data.id !== this.curMpCaseData.id 
            && this.$route.name !== "multiplePeopleCaseDetail") {
              this.showMpCaseNotification = true;
          }
            
          this.curMpCaseData = data;
      });


      this.$mpCaseHub.conn.on("MPCaseFinished", (data) => {
        console.log("监听收到开箱成功通知1", data);

          if(data.id === this.curMpCaseData.id) 
            this.showMpCaseNotification = false;

        let players = data.players.filter(
          (item) => item.id == this.curUserRealId
        );
        console.log("players==", players);
        if (players.length > 0) {
          this.$toast.success(`合开箱【${data.cases[0].name}】打开中~`);
          this.getMultiplePeopleCaseRecentList();
          setTimeout(() => {
            this.$toast.success(`合开箱【${data.cases[0].name}】已打开~`);
            return;
          }, 15000);
        }
      });
    },
    async getCaseList() {
      this.mpCaseList.caseData = [];
      this.mpCaseList.battleCaseList = [];

      const boxList_response = await apis.boxList();
      if (boxList_response.data.code !== 0) {
              return;
      }
      
      const boxList = boxList_response.data.data;

      boxList.list.forEach((item) => {
        if (item.caseType == "0") {
          this.mpCaseList.battleCaseList.push(item);
          let newObj = { ...item, count: 0 };
          this.mpCaseList.caseData.push(newObj);
        }
      });
    },
    async getMultiplePeopleCaseRecentList() {
      let _this = this,
        params = {
          pageIndex: 1,
          pageSize: 100,
        };
      if (this.isRequest) return;
      this.isRequest = true;
      apis.multiplePeopleCaseRecentList(params).then((res) => {
        if (res.data.code !== 0) {
          return;
        }
        _this.multiplePeopleCaseRecentList = res.data.data.items.slice(0, 6);
        for (
          let index = 0;
          index < _this.multiplePeopleCaseRecentList.length;
          index++
        ) {
          const item = _this.multiplePeopleCaseRecentList[index];
          item["joinPrice"] = 0;
          item["joinRatio"] = 0;
          item.endTime = new Date(item.endTime).getTime();
          if (item.cases && item.cases.length == 1) {
            item["currentCaseName"] = item.cases[0].name;
          } else if (item.cases && item.cases.length > 1) {
            item.cases.sort((a, b) => b.price - a.price);
            item["currentCaseName"] = `${item.cases[0].name}...`;
          }
          if (item.players && item.players.length > 0) {
            item.players.forEach((player) => {
              player["ratio"] = `${Math.floor(
                (player.amount / item.price) * 100
              )}`;
              if (this.curUserRealId == player.id) {
                item.joinPrice = player.amount;
                item.joinRatio = player.ratio;
              }
            });
          }
        }
        setTimeout(() => {
          this.isRequest = false;
        }, 3000);
      });
    },
    async createNewMultiplepeopleCase(data) {
      let lpMsg = await this.$mpCaseHub.conn.invoke(
        "GCRequestCreateMPCase",
        data
      );
      if (lpMsg.success) {
        await this.$toast.success(lpMsg.data);
        await this.$refs.cNewMultiplepeopleCase.reset();
        this.new_multiplePeople_cases_show = false;
        await this.$store.commit("setInfo");
        await this.getMultiplePeopleCaseRecentList(); //获取房间列表
      } else {
        this.$toast.error(lpMsg.msg);
        this.$refs.cNewMultiplepeopleCase.reset();
      }
    },
    handleShowmultiplePeopleCaseDetail(item) {
      this.$router.push({
        name: "multiplePeopleCaseDetail",
        params: { id: item.id },
        query: this.$route.query || {},
      });
    },
    async GetAcl() {
      const getAcl = await apis.api_GetAcl();
      this.aclList = JSON.parse(getAcl.data.msg);
      this.$store.commit("setAcl", this.aclList);
    },
    async GetFeatureAccess() {
      const response = await apis.api_GetFeatureAccess();
      if (response.data.code === 0) {
        this.$store.commit(
          "setFeatureAccess",
          normalizeFeatureAccess(response.data.data)
        );
      }
    },
    async refreshFrontendAccess() {
      await this.GetFeatureAccess();
      await this.GetAcl();
      await this.onAclHandle();
    },
    isNavItemVisible(item) {
      return item.show !== false
        && this.$canShowFeature(item.featureKey)
        && this.aclList.indexOf(item.path) === -1;
    },
    async onAclHandle() {
      console.log("查看aclList===", this.aclList);
      this.navsList.forEach(async (item) => {
        item.isShowList = [];
        if (item.children && item.children.length > 0) {
          // console.log("第一层===", item);
          item.children.forEach(async (childrenItem) => {
            childrenItem.isShowList = [];
            if (childrenItem.children && childrenItem.children.length > 0) {
              // console.log("第二层===", childrenItem);
              await childrenItem.children.forEach((grandChild) => {
                // console.log("第三层===", grandChild);
                if (this.isNavItemVisible(grandChild)) {
                  childrenItem.isShowList.push("1");
                }
              });
              // console.log("第三层", childrenItem.isShowList);
              if (childrenItem.isShowList.length > 0) {
                item.isShowList.push("1");
              }
            } else {
              if (this.isNavItemVisible(childrenItem)) {
                item.isShowList.push("1");
              }
            }
          });
        }
      });
    },
    onBottomTabHandle(data) {
      console.log("data==", data);
      if (data.location != "") {
        if (this.$route.name == data.location.name) return;
        this.$router.push({ name: data.location.name });
        this.parentIndex = "";
      } else {
        if (this.parentIndex == data.index) {
          this.parentIndex = "";
        } else {
          this.parentIndex = data.index;
        }
      }
      this.lastResultIndex = "";
      this.activeIndex = "";
    },
    handleMenuSelect(key) {
      this.parentIndex = "";
      this.activeIndex = key;
      this.lastResultIndex = key.indexOf("-") > -1 ? key.split("-")[0] : key;
      let keyList = key.split("-"),
        keyLength = keyList.length,
        routerPath = "";
      console.log("keyList==", keyList);
      if (keyLength == "1") {
        routerPath = this.navsList[keyList[0] - 1].location;
      } else if (keyLength == "2") {
        routerPath =
          this.navsList[keyList[0] - 1].children[keyList[1] - 1].location;
      } else if (keyLength == "3") {
        routerPath =
          this.navsList[keyList[0] - 1].children[keyList[1] - 1].children[
            keyList[2] - 1
          ].location;
      }
      console.log("routerPath==", routerPath);
      // 直接导航到目标路径
      const navigation = routerPath.params
        ? { name: routerPath.name, params: routerPath.params }
        : { name: routerPath.name, query: routerPath.query };

      // 使用 nextTick 确保导航操作在下一个事件循环中执行
      this.$nextTick(async () => {
        resetRouter(); //执行方法
        await this.$router.push(navigation);
      });
    },
    // 获取历史活动来判断是否有进行中的
    getRanks() {
      this.hasRank = false;
      sessionStorage.setItem("hasRank", 0);
      api_RankingEvents().then((res) => {
        if (res?.data?.data) {
          const data = res.data.data;
          if (
            data.monthRankingEvents.otherEvents &&
            data.monthRankingEvents.otherEvents.find((item) => item.status == 0)
          ) {
            this.hasRank = true;
          }
          if (
            data.weekRankingEvents.otherEvents &&
            data.weekRankingEvents.otherEvents.find((item) => item.status == 0)
          ) {
            this.hasRank = true;
          }
          if (
            data.dayRankingEvents.otherEvents &&
            data.dayRankingEvents.otherEvents.find((item) => item.status == 0)
          ) {
            this.hasRank = true;
          }
          if (data.dayRankingEvents?.currEvents?.length) {
            this.hasRank = true;
          }
          if (data.monthRankingEvents?.currEvents?.length) {
            this.hasRank = true;
          }
          if (data.weekRankingEvents?.currEvents?.length) {
            this.hasRank = true;
          }

          if (this.hasRank) {
            sessionStorage.setItem("hasRank", 1);
          }
        }
      });
    },
    formatName(name) {
      return name.length > 10 ? name.slice(0, 10) + "..." : name;
    },
    openWelfareModal(welfareCat) {
      this.welfareCat = welfareCat;
      this.welfareCenterFlag = true;
    },
    conversion,
    openMenu() {
      this.user_drop_menu_show = !this.user_drop_menu_show;
      this.$refs.usermenu.user_drop_menu_show = this.user_drop_menu_show;
    },
    onCloseDropMenuHandle() {
      this.user_drop_menu_show = false;
    },

    bind_idcard() {
      if (this.modal.bindIdCard.length < 18) {
        return this.$toast.error("请输入正确的18位身份证");
      }

      apis.api_BindIdCard({ val: this.modal.bindIdCard }).then((res) => {
        if (res.data.code === 0) {
          this.$toast.success("实名认证成功");
          this.user.idCard = this.modal.bindIdCard;
          this.setPayModal(true);
          this.PayModal.idflag = false;
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },
    handleonmousedown() {
      if (!this.isMute) {
        this.clickSound.pause();
        this.clickSound.volume = 0.3;
        this.clickSound.playbackRate = 2.0;  
        this.clickSound.currentTime = 0;
        this.clickSound.play();
      }
    },
    routeReload() {
      this.isRouterAlive = false;

      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

    //首页欢迎点击方法
    indexFlagClock() {
      this.setloginModal(true);
      this.indexFlagClose();
    },

    //首页欢迎关闭方法
    indexFlagClose() {
      this.transitionFlag = false;
      setTimeout(() => {
        this.indexFlag = false;
      }, 300);
      this.$cookies.set("indexflag", true, "1d");
    },

    //关闭登录
    loginClose(visible_change) {
      if (visible_change === true) return;

      sessionStorage.removeItem("loginModal");
      this.loginModal.active = "sign_in";

      for (const key in this.loginModal.from) {
        if (key === "agree") {
          this.loginModal.from[key] = false;
        } else {
          this.loginModal.from[key] = "";
        }
      }
    },
    onAuthorizedLoginHanlde(item) {
      // const origin = window.location.origin;
      // window.location.href =
      //   configs.autoSSOLoginURL +
      //   "?response_type=code&client_id=jincsgo&redirect_uri=" +
      //   origin +
      //   "&scope=openid%20profile%20email";
    },

    pathGo(obj) {
      if (obj.params) {
        if (obj.params.edgeColor === "tradeup") {
          return this.$router.push({ name: "upgrade" });
        }
      }
      if (obj.name === "case") {
        return this.$router.push({
          name: "case",
          params: { id: obj.id },
          query: this.$route.query || {},
        });
      }
      this.$router.push({ ...obj, query: { ...(this.$route.query || {}), ...(obj.query || {}) } });
    },

    //转换导航
    async switchRoute(path) {
      let allNavs = [];
      await this.navsList.forEach((item) => {
        if (item.location && item.location != "") {
          allNavs.push({
            index: item.index,
            location: item.location,
          });
        }
        if (item.children && item.children.length > 0) {
          item.children.forEach((child) => {
            if (child.location && child.location != "") {
              allNavs.push({
                index: child.index,
                location: child.location,
              });
            }
            if (child.children && child.children.length > 0) {
              child.children.forEach((grandChild) => {
                if (grandChild.location && grandChild.location != "") {
                  allNavs.push({
                    index: grandChild.index,
                    location: grandChild.location,
                  });
                }
              });
            }
          });
        }
      });
      console.log("path==", path);
      console.log("allNavs==", allNavs);
      this.activeIndex = allNavs.find(
        (item) => item.location.name == path
      )?.index;
      console.log("this.activeIndex==", this.activeIndex);
      if (this.$screen.mobile) {
        this.lastResultIndex =
          this.activeIndex && this.activeIndex.indexOf("-") > -1
            ? this.activeIndex.split("-")[0]
            : this.activeIndex;
      }
    },

    /** 手机号注册 */
    mobileRegister() {
      if (!/^1\d{10}$/.test(this.modal.mobileSignData.phone))
        return this.$toast.error("手机号格式不正确");

      // 密码验证
      if (!Validation.password(this.modal.mobileSignData.password))
        return this.$toast.error("密码格式不正确,请输入6~16位英文数字符号组合");

      if (this.modal.mobileSignData.code === "")
        return this.$toast.error("请正确的输入验证码");

      if (!this.loginModal.from.agree)
        return this.$toast.error("请阅读并勾选用户条款");

      this.isSubmit = true;

      mobileRegisterApi({
        phone: this.modal.mobileSignData.phone, //手机号
        password: this.modal.mobileSignData.password, //密码
        vcode: this.modal.mobileSignData.code, //短信验证码
        promote: this.loginModal.from.inviteD || sessionStorage.getItem("code"), //邀请码
        channel: sessionStorage.getItem("channel"), //渠道
        utmtype: sessionStorage.getItem("utmtype"),
        utmkeyword: sessionStorage.getItem("utmkeyword"),
      })
        .then((res) => {
          this.isSubmit = false;
          if (res.data.code === 0) {
            this.$toast.success("注册成功");
            this.setloginModal({ flag: false });
            sessionLogin({
              username: this.modal.mobileSignData.phone,
              password: this.modal.mobileSignData.password,
            }).then(async (res) => {
              if (res.data.code === 0) {
                this.loginModal.flag = false;
                await this.onInitData();
                await this.getboxList();
                await this.RequestTradeOffer();
                await this.$caseBattleHub.conn.stop(); //登录后重置hub连接状态
                await this.$caseBattleHub.conn.start();
                await this.$mpCaseHub.conn.stop(); //登录后重置hub连接状态
                await this.$mpCaseHub.conn.start();
                await this.$crashHub.conn.stop(); //登录后重置hub连接状态
                await this.$crashHub.conn.start();
                await this.$wheelHub.conn.stop(); //登录后重置hub连接状态
                await this.$wheelHub.conn.start();
                if (this.$route.name === "partner") this.routeReload();
              } else {
                this.$toast.error(res.data.msg);
              }
            });
          } else {
            this.$toast.error(res.data.msg);
          }
        })
        .catch(() => {
          this.isSubmit = false;
        });
    },
    /** 获取手机验证码 */
    getMobileCode(prop, mobile) {
      let api = {
        sendMobileCode, //手机号注册发送验证码
        sendResetCode, //手机号修改密码发送验证码
      };

      if (!/^1\d{10}$/.test(mobile.phone)) {
        return this.$toast.error("请填写正确的手机号");
      }

      if (mobile.time !== 61) return;

      mobile.time = 60;

      api[prop]({ val: mobile.phone, captcha: mobile.captchaCode }).then(
        (res) => {
          if (res.data.code === 0) {
            this.timeCounter(mobile);
          } else {
            this.$toast.error(res.data.msg);
            mobile.time = 61;
          }
        }
      );
    },

    //验证码倒计时
    timeCounter(data) {
      data.time = 60;
      let id = setInterval(() => {
        data.time -= 1;
        this.modal.resetWithPhone.time = data.time;
        if (data.time == 0) {
          data.time = 61;
          clearInterval(id);
        }
      }, 1000);
    },
    //登录
    async sessionLoginPost({ email, password } = { ...obj }) {
      if (!this.loginModal.from.agree)
        return this.$toast.error("请阅读并勾选用户条款");

      if (email && password) {
        this.isSubmit = true;
        sessionLogin({ username: email, password })
          .then(async (res) => {
            this.isSubmit = false;
            if (res.data.code === 0) {
              this.loginModal.flag = false;
              this.loginModal.isLoginSuccess = "success";
              Cookies.setToken(res.data.authToken);
              this.$toast.success("登陆成功");
              await this.onInitData();
              if (this.$route.name === "partner") this.routeReload();
              await this.getboxList();
              await this.RequestTradeOffer();
              await this.$caseBattleHub.conn.stop(); //登录后重置hub连接状态
              await this.$caseBattleHub.conn.start();
              await this.$mpCaseHub.conn.stop(); //登录后重置hub连接状态
              await this.$mpCaseHub.conn.start();
            } else {
              this.$toast.error(res.data.msg);
            }
          })
          .catch(() => {
            this.isSubmit = false;
          });
      } else {
        this.$toast.error("请确保已填写账号和密码");
      }
    },

    loginFirstC() {
      this.loginFirst = false;
      this.setloginModal(true);
    },
    getCurrentUrl() {
      return window.location.hostname;
    },
    async getGlobalInfo() {
      let res = await GetSystemInfo();
      if (res.data.code === 0) {
        this.systemAuthSwitch.System_Register = res.data.data.system_Register;
        this.systemAuthSwitch.System_Login = res.data.data.system_Login;
        this.setSystemAuthSwitch(this.systemAuthSwitch);

        if (res.data.data.notices) {
          this.setNoticeList(res.data.data.notices);
        }

        if (res.data.data.banners) {
          this.setBannerList(res.data.data.banners);
        }

        //获取加群链接
        this.GobalInfo.GroupLink = res.data.data.qqgrouplink;
        this.GobalInfo.ServiceLink = res.data.data.qqlink;
        //TEMP
        const domain = window.location.hostname.split(".").reverse()[1];
        if (domain === "jinhe66") {
          this.GobalInfo.GroupLink =
            "https://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=KwkrPSIhZj4Q1_dGDl1PIkMEMCJJHKR8&authKey=INZYVpFLhZpUAUTBUQBRDWA4wVU%2FCT6Z%2Bwb1lAJUrohTMeyUg0BQA%2FrsMhguYo5G&noverify=0&group_code=814952223";
        }
        this.GobalInfo.caseCount = res.data.data.caseCount;
        this.GobalInfo.userCount = res.data.data.userCount;
        this.GobalInfo.luckyItemCount = res.data.data.luckyItemCount;
        this.GobalInfo.battleCount = res.data.data.battleCount;
        this.GobalInfo.contractPriceRate = res.data.data.contractPriceRate;
      }
    },

    //关闭公告
    AlertClose(e) {
      e.stopPropagation();

      this.$cookies.set("Alert", this.announcementText, "7d");
      this.Alert = false;
    },

    //退出登录
    logOut() {
      let mesRes = this.$confirm("是否确认退出登录?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        confirmButtonClass: "confirmButtonClass",
      }).then(async () => {
        this.loginModal.isLoginSuccess = null;
        //关闭mpCaseHub的websocket连接
        this.$mpCaseHub.onConnected = null;
        this.$mpCaseHub.onReconnected = null;
        this.$mpCaseHub.conn.off("MPCaseFinished");
        //关闭caseBattleHub的websocket连接
        this.$caseBattleHub.onConnected = null;
        this.$caseBattleHub.onReconnected = null;
        this.$caseBattleHub.conn.off("GCUpdateRoomRecv");
        this.$caseBattleHub.conn.off("GCChallengeFailedRecv");

        sessionStorage.clear();
        sessionStorage.removeItem("user");
        Cookies.removeToken();
        localStorage.removeItem("lastCreateNewCase");
        this.setInfo();
        await this.GetFeatureAccess();
        await this.onAclHandle();
        this.toggle_header_info_bar_user_info_active();
        //this.$refs.sidebar.set_active_offer_count(0);

        // 添加更严格的检查，避免重复导航
        if (this.$route.name !== "home" && this.$route.path !== "/") {
          this.$router.push({ name: "home" });
        }
      });
    },
    /** 切换 侧边栏显示状态 */
    async toggle_sidebar_show() {
      this.is_sidebar_show = !this.is_sidebar_show;
    },

    /** 切换 页眉信息栏 用户信息 是否激活 */
    async toggle_header_info_bar_user_info_active(is_active) {
      if (typeof is_active !== "undefined") {
        this.is_header_info_bar_user_info_active = is_active;
        return;
      }

      this.is_header_info_bar_user_info_active =
        !this.is_header_info_bar_user_info_active;
    },

    /** 切换 客服信息激活状态 */
    async toggle_service_active() {
      // this.is_service_active = !this.is_service_active;
      this.$store.state.GroupLink &&
        window.open(this.$store.state.GroupLink, "_blank");
    },

    /** 公告栏Swiper初始化 */
    async on_bulletion_board_swiper_readied(swiper) {
      const bulletion_board_width = this.$refs["bulletion_board"].offsetWidth;
      const bulletion_board_text_width =
        this.$refs["bulletion_board_text"].offsetWidth;

      this.can_autoplay_bulletion_board =
        bulletion_board_text_width > bulletion_board_width * 0.96;

      swiper.init();
      swiper.update();
    },
    /** 发送重置登录密码验证码 */
    async send_reset_sign_in_password_code({ phone, time_data }) {
      if (time_data.time !== 61) return;

      const send_reset_sign_in_password_code_response =
        await apis.send_reset_sign_in_password_code({ phone: phone });

      this.timeCounter(time_data);

      if (send_reset_sign_in_password_code_response.data.code !== 0) {
        this.$toast.error(send_reset_sign_in_password_code_response.data.msg);
      }

      this.$toast.success("发送成功");
    },

    /** 重置登录密码 */
    async reset_sign_in_password() {
      let code = this.modal.resetWithPhone.code;
      let phone = this.modal.resetWithPhone.phone;
      let password = this.modal.resetWithPhone.password;

      //手机号验证
      if (!/^1\d{10}$/.test(phone)) {
        return this.$toast.error("请填写正确的手机号");
      }
      // 密码验证
      if (!Validation.password(password))
        return this.$toast.error("密码格式不正确,请输入6~16位英文数字符号组合");

      // 验证码验证
      if (!code.length) return this.$toast.error("请正确的输入验证码");

      const reset_sign_in_password_response = await apis.reset_sign_in_password(
        {
          phone: phone,
          password: password,
          vcode: code,
        }
      );

      if (reset_sign_in_password_response.data.code === 0) {
        this.loginModal.active = "sign_in";
        this.$toast.success(reset_sign_in_password_response.data.msg);
      } else {
        this.$toast.error(reset_sign_in_password_response.data.msg);
      }
    },

    isShowDropComp() {
      // 设计稿首页无 live-drop，首页统一不展示
      if (this.$route.path === '/' || this.$route.name === 'home') {
        this.isShowLiveDrop = false;
        return;
      }
      let isMobile = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (isMobile) {
        this.isShowLiveDrop = false;
      } else {
        this.isShowLiveDrop = true; // PC 非首页展示
      }
    },
    bb(e) {
      if (this.$screen.mobile) {
        for (const key in this.$refs) {
          if (key.indexOf("submenu") != -1) {
            if (key.indexOf(e.currentTarget.id) != -1) {
              this.$refs[key][0].show(this.$refs[key][0]);
            } else {
              this.$refs[key][0].hide(this.$refs[key][0]);
            }
          }
        }
      }

      // console.log(5555,e.target.$ref)
    },

    resolvePath(location) {
      return this.$router.resolve(location).href;
    },

    checkAcl(location) {
      // console.log('查看当前路由地址===',this.$route.name);
      return !this.$store.state.acl.includes(
        this.$router.resolve(location).href
      );
    },
    handleCommand(command) {
      console.log("command==", command);
      // location.reload();
      window.translate.changeLanguage(command);
      localStorage.setItem("language", command);
      this.language = command;
      window.translate.execute();
    },
    onGotoQQHandle() {
      window.open(this.GobalInfo.GroupLink);
    },
  },
};
